import { DefaultTheme } from 'styled-components';
import { IVisualStates } from '@agilepoint/utils-type';

export const selectStyleByState = (theme: DefaultTheme, state: keyof Pick<IVisualStates<any>, 'default' | 'disabled'>) => theme.slider.colors[state];

interface ISelectionUtilityOptions {
    min: number;
    max: number;
    step: number;
}

export class KnobUtility {

    constructor(private options: ISelectionUtilityOptions) { }

    private getValidValue(value: number) {
        const { step } = this.options;
        if (value % step === 0) {
            return value;
        }
        const roundedMultiplier = Math.round(value / step);
        return roundedMultiplier * step;
    }

    getPosition = (value: number, isEnd?: boolean) => {
        const { max, min } = this.options;
        const distFromBase = (value - min) * 100 / (max - min);
        if (isEnd) {
            return 100 - distFromBase;
        }
        return distFromBase;
    }

    getValue = (position: number) => {
        const { max, min } = this.options;
        return this.getValidValue(((max - min) * position / 100) + min);
    }
}

export function findDirection(position: number, pointA: number, pointB: number) {
    const distPA = position - pointA;
    const distPB = position - pointB;
    const closestPoint = Math.abs(distPA) < Math.abs(distPB) ? 1 : -1;
    return [closestPoint, (closestPoint === 1 ? distPA : distPB) < 0 ? -1 : 1];
}
